/* import __COLOCATED_TEMPLATE__ from './date-calendar-redesign.hbs'; */
import { classNames } from '@ember-decorators/component';
import RequestDateDateCalendar from './date-calendar';
import styles from './date-calendar-redesign.module.scss';

@classNames('date-calendar-redesign', styles.component)
export default class RequestDateDateCalendarRedesign extends RequestDateDateCalendar {
  styles = styles;
}
